<template>
  <div class="producer-audit">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">申请时间</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">手机号</span>
        <el-input
          class="w200"
          maxlength="20"
          v-model="telephone"
          placeholder="请输入申请人手机号"
        ></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">审核状态</span>
        <el-select v-model="checkStatus" placeholder="请选择审核状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </div>
      <!-- <div class="condition-wrap">
        <span class="condition-label">认领状态</span>
        <el-select v-model="claimStatus" placeholder="请选择认证状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="成功" value="1"></el-option>
          <el-option label="失败" value="2"></el-option>
        </el-select>
      </div> -->
      <div class="condition-wrap">
        <el-button type="primary" @click="searchGetList(1)">筛选</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
      <el-table-column prop="authorName" label="申请人" align="center"></el-table-column>
      <el-table-column prop="telephone" label="手机号" align="center"></el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.authorType == 1 ? '个人' : '公司' }}
        </template>
      </el-table-column>
      <el-table-column prop="idNum" label="身份证号码" align="center"></el-table-column>
      <!-- <el-table-column prop="updateTime" label="申请时间" align="center"></el-table-column> -->
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.checkStatus == 2"
            @click="searchFailReason(scope.row.checkReason)"
            type="primary"
            >{{ checkStatusObj[scope.row.checkStatus] }}</el-link
          >
          <span v-else>{{ checkStatusObj[scope.row.checkStatus] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ aliVerityStatusObj[scope.row.aliVerityStatus] }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="申请时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.checkStatus == '0'"
            size="small"
            type="primary"
            @click="showAuditModal(scope.row.authorId)"
            >审核</el-button
          >
          <el-button size="small" type="primary" @click="searchDetail(scope.row.authorId)"
            >查看详情</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="showPercentModal(scope.row.authorId, scope.row.percentage)"
            >分成设置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="searchGetList"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog title="查看详情" :visible.sync="showAddPop" width="500px">
      <el-form v-if="showAddPop" size="small" label-width="120px">
        <el-form-item label="类型：">
          <template>
            <el-radio disabled v-model="detail.authorType" label="1">个人</el-radio>
            <el-radio disabled v-model="detail.authorType" label="2">公司</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="生产者" prop="authorName">
          <el-input
            readonly
            v-model="detail.authorName"
            maxlength="30"
            placeholder="请输入生产者"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="detail.authorType == 2" label="所属公司名称" prop="authorInfo">
          <el-input
            readonly
            v-model="detail.authorInfo"
            maxlength="30"
            placeholder="请输入所属公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="telephone">
          <el-input
            readonly
            v-model="detail.telephone"
            maxlength="11"
            placeholder="请输入移动电话"
          ></el-input>
          <span style="color:red;font-size:12px;">（作为登录账号使用）</span>
        </el-form-item>
        <el-form-item label="国家">
          <el-select disabled v-model="detail.countryType">
            <el-option label="国内" value="2"></el-option>
            <el-option label="国外" value="3"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="detail.authorType == 1">
          <el-form-item label="身份证姓名" prop="realName">
            <el-input
              readonly
              v-model="detail.realName"
              maxlength="30"
              placeholder="请输入身份证姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            <el-select disabled v-model="detail.idType">
              <el-option label="身份证" value="1"></el-option>
              <el-option label="护照" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="idNum">
            <el-input
              readonly
              v-model="detail.idNum"
              maxlength="30"
              placeholder="请输入证件号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件正面" prop="idFrontPic">
            <el-image
              style="width: 150px; height: 150px"
              :src="detail.idFrontPicUrl"
              :preview-src-list="[detail.idFrontPicUrl]"
            >
            </el-image>
          </el-form-item>
          <el-form-item label="证件反面" prop="idBackPic">
            <el-image
              style="width: 150px; height: 150px"
              :src="detail.idBackPicUrl"
              :preview-src-list="[detail.idBackPicUrl]"
            >
            </el-image>
          </el-form-item>
        </template>
        <template v-if="detail.authorType == 2">
          <el-form-item label="申请人" prop="realName">
            <el-input
              readonly
              v-model="detail.realName"
              maxlength="30"
              placeholder="请输入生产者"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idNum">
            <el-input
              readonly
              v-model="detail.idNum"
              maxlength="18"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司营业执照号" prop="businessLicNo">
            <el-input
              readonly
              v-model="detail.businessLicNo"
              maxlength="30"
              placeholder="请输入公司营业执照号"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="companyAddr">
            <el-input
              readonly
              v-model="detail.companyAddr"
              maxlength="30"
              placeholder="请输入公司地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="固定电话" prop="landlineTel">
            <el-input
              readonly
              v-model="detail.landlineTel"
              maxlength="30"
              placeholder="请输入公司固定电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证正面" prop="idFrontPic">
            <el-image
              style="width: 150px; height: 150px"
              :src="detail.idFrontPicUrl"
              :preview-src-list="[detail.idFrontPicUrl]"
            >
            </el-image>
          </el-form-item>
          <el-form-item label="法人身份证反面" prop="idBackPic">
            <el-image
              style="width: 150px; height: 150px"
              :src="detail.idBackPicUrl"
              :preview-src-list="[detail.idBackPicUrl]"
            >
            </el-image>
          </el-form-item>
          <el-form-item label="营业执照照片" prop="businessLicPic">
            <el-image
              style="width: 150px; height: 150px"
              :src="detail.businessLicPicUrl"
              :preview-src-list="[detail.businessLicPicUrl]"
            >
            </el-image>
          </el-form-item>
        </template>
        <template>
          <el-form-item label="支付宝收款人" prop="alipayPayee">
            <el-input
              readonly
              v-model="detail.alipayPayee"
              maxlength="30"
              placeholder="请输入支付宝收款人"
            ></el-input>
          </el-form-item>
          <el-form-item label="支付宝账户" prop="alipayAccount">
            <el-input
              readonly
              v-model="detail.alipayAccount"
              maxlength="30"
              placeholder="请输入支付宝账户"
            ></el-input>
          </el-form-item>
        </template>
        <!-- <template v-if="detail.authorType == 2">
          <el-form-item label="支付宝收款人" prop="alipayPayee">
            <el-input readonly v-model="detail.alipayPayee" maxlength="30" placeholder="请输入开户行"></el-input>
          </el-form-item>
          <el-form-item label="开户名称" prop="alipayAccount">
            <el-input readonly v-model="detail.alipayAccount" maxlength="30" placeholder="请输入开户名称"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="accountNo">
            <el-input readonly v-model="detail.accountNo" maxlength="30" placeholder="请输入账号"></el-input>
          </el-form-item>
        </template> -->
        <el-form-item label="分成比例">
          <el-input v-model="detail.percentage" :readonly="true" maxlength="30">
            <template slot="append"
              >%</template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input
            readonly
            type="textarea"
            v-model="detail.remark"
            rows="3"
            maxlength="100"
            show-word-limit
            placeholder="请输入介绍"
          ></el-input>
        </el-form-item>
        <el-form-item label="作者照片">
          <el-image
            style="width: 150px; height: 150px"
            :src="detail.authorPicUrl"
            :preview-src-list="[detail.authorPicUrl]"
          >
          </el-image>
        </el-form-item>
        <el-form-item label="文档介绍">
          <MyUpload
            disabled
            :on-preview="downloadVideoSource"
            info="仅支持pdf, 小于20M"
            accept="application/pdf"
            list-type="text"
            :imgKey.sync="detail.vedioSource"
            :url="detail.vedioSourceUrl"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="showAddPop = false">取 消</el-button>
        <el-button type="primary" @click="showAddPop = false">确 定</el-button>
      </div>
    </el-dialog>
    <AuditDialog ref="auditDialog" @fail="fail" @success="success" />
    <PercentDialog ref="percentDialog" :percent.sync="currentPercent" @complete="complete" />
  </div>
</template>

<script>
import API, { baseUrl } from '../lib/API'
import AuditDialog from '../components/common/AuditDialog.vue'
import PercentDialog from '../components/common/PercentDialog.vue'
import dayjs from 'dayjs'
import MyUpload from '../components/common/MyUpload.vue'
export default {
  name: 'ProducerAudit',
  components: {
    AuditDialog,
    PercentDialog,
    MyUpload
  },
  data() {
    return {
      showAddPop: false,
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      date: [],
      telephone: '',
      checkStatus: '',
      claimStatus: '',
      auditVisible: false,
      currentAuthorId: '',
      currentPercent: '',
      aliVerityStatusObj: {
        0: '未认证',
        1: '成功',
        2: '失败'
      },
      checkStatusObj: {
        0: '待审核',
        1: '审核通过',
        2: '审核失败'
      },
      detail: {
        authorType: 1,
        authorName: '',
        authorInfo: '',
        telephone: '',
        countryType: 2,
        realName: '',
        idType: 1,
        idNum: '',
        idFrontPic: '',
        idFrontPicUrl: '',
        idBackPic: '',
        idBackPicUrl: '',
        businessLicNo: '',
        companyAddr: '',
        landlineTel: '',
        businessLicPic: '',
        businessLicPicUrl: '',
        alipayPayee: '',
        alipayAccount: '',
        accountNo: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    downloadVideoSource() {
      this.download(this.detail.vedioSource)
    },
    download(designPdf) {
      let a = document.createElement('a')
      a.href = `${baseUrl}/download/image?key=${designPdf}&accesstoken=${localStorage.getItem(
        'token'
      )}`
      a.click()
    },
    searchFailReason(reason) {
      this.$alert(reason, '失败原因')
    },
    searchGetList(val) {
      this.pageNum = val
      this.getList()
    },
    searchDetail(authorId) {
      this.showAddPop = true
      new API(this).POST({
        url: `/author/getAuthorDetail?authorId=${authorId}`,
        cb: res => {
          Object.assign(this.detail, res)
        }
      })
    },
    complete() {
      new API(this).POST({
        url: '/author/setPercentage',
        params: {
          authorId: this.currentAuthorId,
          percentage: this.currentPercent
        },
        cb: res => {
          this.$notify({
            title: '操作成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        }
      })
    },
    showAuditModal(authorId) {
      this.currentAuthorId = authorId
      this.$refs.auditDialog.showModal()
    },
    hideAuditModal() {
      this.$refs.auditDialog.hideModal()
    },
    showPercentModal(authorId, percent) {
      this.currentAuthorId = authorId
      this.currentPercent = percent
      this.$refs.percentDialog.showModal()
    },
    hidePercentModal() {
      this.$refs.percentDialog.hideModal()
    },
    auditMethod(checkStatus, reason) {
      new API(this).POST({
        url: '/author/audit',
        params: {
          authorId: this.currentAuthorId,
          checkStatus,
          reason
        },
        cb: res => {
          this.getList()
        }
      })
    },
    fail(reason) {
      this.auditMethod(2, reason)
    },
    success() {
      this.auditMethod(1, '')
    },
    getList() {
      let startTime = ''
      let endTime = ''
      if (this.date && this.date.length > 0) {
        startTime = dayjs(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00'
        endTime = dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      new API(this).POST({
        url: '/author/listAuditAuthorPage',
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          startTime,
          endTime,
          telephone: this.telephone,
          checkStatus: this.checkStatus,
          claimStatus: this.claimStatus
        },
        cb: res => {
          let { pages, result } = res
          this.totalPage = pages
          this.tableData = result
        }
      })
    }
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/ClaimAudit.vue